import useMultipleSelect from "@/components/shared/tables/multiSelect";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";
import type { CellContext, Row } from "@tanstack/react-table";

export const SelectCell = ({
  row,
  table,
  canSelectRow,
  disabled,
  readOnly,
}: CellContext<any, unknown> & {
  canSelectRow?: (row: Row<unknown>) => boolean;
  disabled?: boolean;
  readOnly?: boolean;
}) => {
  const { setCurrentSelectValue, setShiftDown } = useMultipleSelect(table);

  const handleSelectionChange = (value: any) => {
    const isSelectable = canSelectRow ? canSelectRow(row) : true;
    if (!isSelectable) {
      return;
    }
    row.toggleSelected(!!value);
    setCurrentSelectValue({ row, value });
  };

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: not needed
    <div
      onClick={(event) => event.stopPropagation()}
      className="flex w-full items-center justify-center h-full"
    >
      <Checkbox
        checked={
          row.getIsSelected() ||
          row.getIsAllSubRowsSelected() ||
          (row.getIsSomeSelected() && "indeterminate")
        }
        onChange={row.getToggleSelectedHandler()}
        onClick={(event: any) => {
          if (event.shiftKey) {
            // should refector this: Problem is that the checkbox does not pass event and value to same handler,
            // so built this custom approach and call two funciotn, one in on click and other in on checked change
            setShiftDown(true);
          }
        }}
        disabled={Boolean(disabled) || Boolean(readOnly)}
        onCheckedChange={handleSelectionChange}
        aria-label="Select row"
        className={cn(
          Boolean(readOnly) && "cursor-not-allowed disabled:opacity-100",
        )}
      />
    </div>
  );
};
